var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container", attrs: { id: "goods-edit" } },
    [
      _c("breadcrumb-top", { attrs: { breadcrumbConfig: _vm.dataList } }),
      _c(
        "div",
        { staticClass: "content c-top" },
        [
          _c("breadcrumb-search", {
            attrs: { breadcrumbSearch: _vm.searchList },
          }),
          _c(
            "el-form",
            {
              ref: "infoForm",
              staticClass: "info-form",
              attrs: {
                model: _vm.infoForm,
                rules: _vm.infoRules,
                "label-width": "100px",
              },
            },
            [
              _c("el-form-item", { attrs: { label: "商品分类" } }, [
                _c("div", { staticClass: "goods-category-edit" }, [
                  _c("span", [_vm._v(_vm._s(_vm.categoryArrStr))]),
                  _vm.currentPageStatus == "add"
                    ? _c(
                        "span",
                        {
                          staticClass: "edit-btn",
                          on: {
                            click: function ($event) {
                              return _vm.toOtherPages("goodsCategoryEdit")
                            },
                          },
                        },
                        [_vm._v("编辑")]
                      )
                    : _vm._e(),
                ]),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "商品类型", prop: "goodsType" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { disabled: _vm.currentPageStatus !== "add" },
                      model: {
                        value: _vm.infoForm.goodsType,
                        callback: function ($$v) {
                          _vm.$set(_vm.infoForm, "goodsType", $$v)
                        },
                        expression: "infoForm.goodsType",
                      },
                    },
                    _vm._l(_vm.goods_types, function (item) {
                      return _c("el-radio", {
                        key: item.dictId,
                        attrs: {
                          value: item.dictId,
                          label: item.dictName,
                          name: item.dictId,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "商品名称", prop: "name" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "442px" },
                    attrs: {
                      placeholder: "请输入商品名称",
                      maxlength: "30",
                      "show-word-limit": "",
                      clearable: "",
                    },
                    model: {
                      value: _vm.infoForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.infoForm, "name", $$v)
                      },
                      expression: "infoForm.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    "font-size": "12px",
                    "font-family": "Microsoft YaHei",
                    "font-weight": "400",
                    "line-height": "0px",
                    color: "#909099",
                    "margin-left": "106px",
                    "margin-top": "24px",
                    "margin-bottom": "18px",
                  },
                  attrs: { label: "" },
                },
                [_vm._v(" 示例：商品品牌-商品属性-商品名称-商品重量 ")]
              ),
              _c("el-form-item", { attrs: { label: "分类标签" } }, [
                _vm.infoForm.tagNameList && _vm.infoForm.tagNameList.length != 0
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "flex-wrap": "wrap",
                          "margin-top": "4px",
                        },
                      },
                      _vm._l(_vm.infoForm.tagNameList, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticStyle: {
                              "margin-right": "24px",
                              height: "32px",
                              background: "#E9ECFE",
                              opacity: "1",
                              "border-radius": "3px",
                              "font-size": "14px",
                              "font-family": "Microsoft YaHei",
                              "font-weight": "400",
                              "line-height": "32px",
                              color: "#303033",
                              "text-align": "center",
                              "padding-left": "8px",
                              "padding-right": "8px",
                            },
                          },
                          [_vm._v(_vm._s(item))]
                        )
                      }),
                      0
                    )
                  : _c("div", [_vm._v("无")]),
              ]),
              _vm.infoForm.goodsNo
                ? _c(
                    "el-form-item",
                    { staticClass: "goods-no", attrs: { label: "商品编码" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "442px" },
                        attrs: { disabled: true },
                        model: {
                          value: _vm.infoForm.goodsNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.infoForm, "goodsNo", $$v)
                          },
                          expression: "infoForm.goodsNo",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { staticClass: "goods-no", attrs: { label: "平台商品编号" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "442px" },
                    model: {
                      value: _vm.infoForm.platformGoodsNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.infoForm, "platformGoodsNo", $$v)
                      },
                      expression: "infoForm.platformGoodsNo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "商品标签" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "442px" },
                    attrs: {
                      placeholder: "请输入商品标签",
                      maxlength: "6",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.infoForm.tag,
                      callback: function ($$v) {
                        _vm.$set(_vm.infoForm, "tag", $$v)
                      },
                      expression: "infoForm.tag",
                    },
                  }),
                ],
                1
              ),
              _c("div", {
                staticStyle: {
                  width: "674px",
                  height: "0px",
                  border: "1px dashed #ebebfa",
                  opacity: "1",
                  "margin-bottom": "6px",
                },
              }),
              _c("el-form-item", { attrs: { label: "类目属性" } }, [
                _c("label", { attrs: { slot: "label" }, slot: "label" }, [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "14px",
                        "font-family": "Microsoft YaHei",
                        "font-weight": "bold",
                        "line-height": "0px",
                        color: "#303033",
                      },
                    },
                    [_vm._v("类目属性")]
                  ),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "content attr",
                    staticStyle: { padding: "0px 0px !important" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "attr-content",
                        staticStyle: { "background-color": "white" },
                      },
                      [
                        _vm._l(_vm.goodsAttrData, function (item, index) {
                          return [
                            _c("h5", { staticStyle: { color: "#303033" } }, [
                              _vm._v("商品属性/" + _vm._s(item.name)),
                            ]),
                            _c(
                              "div",
                              { staticClass: "attr-list" },
                              [
                                _vm.infoForm.goodsVerifyStatus == "3"
                                  ? _c("form-filed1", {
                                      ref: "formAttr" + item.id,
                                      refInFor: true,
                                      attrs: {
                                        formconfig: item.formconfig,
                                        formData: item.formData,
                                      },
                                      on: { formDataval: _vm.dialogClick },
                                    })
                                  : _c("form-filed", {
                                      ref: "formAttr" + item.id,
                                      refInFor: true,
                                      attrs: {
                                        formconfig: item.formconfig,
                                        formData: item.formData,
                                      },
                                      on: { formDataval: _vm.dialogClick },
                                    }),
                              ],
                              1
                            ),
                          ]
                        }),
                      ],
                      2
                    ),
                  ]
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm.infoForm.goodsType != "赠品"
        ? _c(
            "div",
            { staticClass: "content image-text-form" },
            [
              _c("h3", [_vm._v("运费设置")]),
              _c(
                "el-form",
                { attrs: { "label-width": "100px" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "" } },
                    [
                      _vm.detail.calculType == 1
                        ? _c("number", {
                            attrs: {
                              isEdit: false,
                              tableData: _vm.tableData,
                              freight: _vm.detail.freight,
                              baseNumber: _vm.detail.baseNumber,
                              addNum: _vm.detail.addNum,
                              addPrice: _vm.detail.addPrice,
                            },
                          })
                        : _vm._e(),
                      _vm.detail.calculType == 2
                        ? _c("weight", {
                            attrs: {
                              isEdit: false,
                              tableData: _vm.tableData,
                              freight: _vm.detail.freight,
                              baseNumber: _vm.detail.baseNumber,
                              addNum: _vm.detail.addNum,
                              addPrice: _vm.detail.addPrice,
                            },
                          })
                        : _vm._e(),
                      _vm.tableDataF.length != 0
                        ? _c("free-delivery", {
                            staticStyle: { "margin-top": "10px" },
                            attrs: { tableData: _vm.tableDataF, isEdit: false },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "content image-text-form" },
        [
          _c("h3", [_vm._v("图文信息")]),
          _c(
            "el-form",
            { attrs: { "label-width": "100px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "商品图片(0/10)" } },
                [
                  _c("label", { attrs: { slot: "label" }, slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v("商品图片(" + _vm._s(this.fileList.length) + "/10)"),
                  ]),
                  _vm.infoForm.goodsVerifyStatus == "3"
                    ? _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        _vm._l(_vm.fileList, function (item, index) {
                          return _c(
                            "div",
                            {
                              key: item + index,
                              staticClass: "itemI",
                              staticStyle: { "margin-left": "8px" },
                            },
                            [
                              _c("el-image", {
                                staticStyle: {
                                  width: "108px",
                                  height: "108px",
                                  "border-radius": "6px",
                                },
                                attrs: { src: item.url },
                              }),
                              index == 0
                                ? _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "#2d46ee",
                                        position: "absolute",
                                        top: "100px",
                                        left: "10px",
                                      },
                                    },
                                    [_vm._v("（商品主图）")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _c("upload-picture", {
                        attrs: { limit: 10, list: _vm.fileList },
                        on: { changeImage: _vm.changeImage },
                      }),
                ],
                1
              ),
              _c("el-form-item", { attrs: { label: "" } }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      "font-size": "12px",
                      "font-family": "Microsoft YaHei",
                      "font-weight": "400",
                      "line-height": "16px",
                      color: "#909099",
                    },
                  },
                  [
                    _vm._v(
                      " 图片尺寸：建议上传750px*750px，每张上传大小不得超过2M,支持jpg、jpeg、png格式 "
                    ),
                  ]
                ),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "商品详情" } },
                [
                  _c("label", { attrs: { slot: "label" }, slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v("商品详情"),
                  ]),
                  _c("quill-editor", {
                    ref: "myQuillEditor",
                    staticClass: "editor",
                    attrs: {
                      options: _vm.editorOption,
                      disabled: _vm.infoForm.goodsVerifyStatus == "3",
                    },
                    model: {
                      value: _vm.infoForm.details,
                      callback: function ($$v) {
                        _vm.$set(_vm.infoForm, "details", $$v)
                      },
                      expression: "infoForm.details",
                    },
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "bottom quill",
                      staticStyle: { display: "none" },
                    },
                    [
                      _c("el-upload", {
                        ref: "uploadicon",
                        staticClass: "centerImg",
                        attrs: {
                          action: " ",
                          "list-type": "picture-card",
                          "auto-upload": false,
                          "on-change": _vm.handleAvatarChangeIcon,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "content", attrs: { id: "sku-content" } }, [
        _c("div", { staticStyle: { display: "flex" } }, [
          _c("h3", [_vm._v("价格库存")]),
          _vm.infoForm.goodsType != "赠品"
            ? _c(
                "div",
                {
                  staticStyle: {
                    color: "#2d46ee",
                    "margin-left": "14px",
                    "font-size": "14px",
                    "line-height": "30px",
                  },
                },
                [
                  _vm._v(
                    " 平台服务商佣金比例：" + _vm._s(_vm.serverRate) + "% "
                  ),
                ]
              )
            : _vm._e(),
          _vm.infoForm.goodsType != "赠品"
            ? _c(
                "div",
                {
                  staticStyle: {
                    color: "#2d46ee",
                    "margin-left": "18px",
                    "font-size": "14px",
                    "line-height": "30px",
                  },
                },
                [_vm._v(" 默认自返佣金比例：" + _vm._s(_vm.userRate) + "% ")]
              )
            : _vm._e(),
          _vm.infoForm.goodsType != "赠品"
            ? _c(
                "div",
                {
                  staticStyle: {
                    color: "#2d46ee",
                    "margin-left": "18px",
                    "font-size": "14px",
                    "line-height": "30px",
                  },
                },
                [
                  _vm._v(
                    " 默认一级佣金比例：" +
                      _vm._s(_vm.firstNormalCommProp) +
                      "% "
                  ),
                ]
              )
            : _vm._e(),
        ]),
        _c("div", { staticClass: "sku-box" }, [
          _c("div", { staticClass: "sku-title" }),
          _c("div", { staticClass: "sku-content-box" }, [
            _c(
              "div",
              { staticClass: "goods-sale-list" },
              [
                _c("SkuForm", {
                  ref: "skuForm",
                  attrs: {
                    "source-attribute": _vm.skuFormConfig.sourceAttribute,
                    attribute: _vm.skuFormConfig.attribute,
                    sku: _vm.skuFormConfig.sku,
                    disabled: _vm.skuFormConfig.showForm,
                    structure: _vm.skuFormConfig.structure,
                  },
                  on: {
                    "update:attribute": function ($event) {
                      return _vm.$set(_vm.skuFormConfig, "attribute", $event)
                    },
                    "update:sku": function ($event) {
                      return _vm.$set(_vm.skuFormConfig, "sku", $event)
                    },
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "image",
                      fn: function (slotImg) {
                        return [
                          _c("mall-picture", {
                            attrs: { imageUrl: slotImg.row.image },
                            on: {
                              getUrl: function ($event) {
                                return _vm.getImage($event, slotImg)
                              },
                            },
                          }),
                        ]
                      },
                    },
                    {
                      key: "settlementPrice",
                      fn: function (slotProps) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                slotProps.row.settlementPrice
                                  ? Number(slotProps.row.settlementPrice)
                                      .toFixed(3)
                                      .substring(
                                        0,
                                        Number(slotProps.row.settlementPrice)
                                          .toFixed(3)
                                          .lastIndexOf(".") + 3
                                      )
                                  : "0.00"
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                    {
                      key: "platformCommissionRate",
                      fn: function (slotProps) {
                        return [
                          _c("div", { staticStyle: { display: "flex" } }, [
                            _c(
                              "div",
                              { staticClass: "rate" },
                              [
                                _c(
                                  "el-input",
                                  {
                                    attrs: { size: "small" },
                                    model: {
                                      value:
                                        slotProps.row.platformCommissionRate,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          slotProps.row,
                                          "platformCommissionRate",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "slotProps.row.platformCommissionRate",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        attrs: { slot: "suffix" },
                                        slot: "suffix",
                                      },
                                      [_vm._v("%")]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "firstNormalCommProp",
                      fn: function (slotProps) {
                        return [
                          _c("div", { staticStyle: { display: "flex" } }, [
                            _c(
                              "div",
                              { staticClass: "rate" },
                              [
                                _c(
                                  "el-input",
                                  {
                                    attrs: { size: "small" },
                                    model: {
                                      value: slotProps.row.firstNormalCommProp,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          slotProps.row,
                                          "firstNormalCommProp",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "slotProps.row.firstNormalCommProp",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        attrs: { slot: "suffix" },
                                        slot: "suffix",
                                      },
                                      [_vm._v("%")]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "platformUserCommission",
                      fn: function (slotProps) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                slotProps.row.platformUserCommission
                                  ? Number(slotProps.row.platformUserCommission)
                                      .toFixed(3)
                                      .substring(
                                        0,
                                        Number(
                                          slotProps.row.platformUserCommission
                                        )
                                          .toFixed(3)
                                          .lastIndexOf(".") + 3
                                      )
                                  : "0.00"
                              ) +
                              " "
                          ),
                          _c("div", { staticClass: "line" }),
                        ]
                      },
                    },
                    {
                      key: "platformCommission",
                      fn: function (slotProps) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                slotProps.row.platformCommission
                                  ? Number(slotProps.row.platformCommission)
                                      .toFixed(3)
                                      .substring(
                                        0,
                                        Number(slotProps.row.platformCommission)
                                          .toFixed(3)
                                          .lastIndexOf(".") + 3
                                      )
                                  : "0.00"
                              ) +
                              " "
                          ),
                          _c("div", { staticClass: "line" }),
                        ]
                      },
                    },
                    {
                      key: "platformProfit",
                      fn: function (slotProps) {
                        return [
                          _c(
                            "div",
                            {
                              style: {
                                color:
                                  Number(slotProps.row.platformProfit) < 0
                                    ? "#F63C56"
                                    : " ",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    slotProps.row.platformProfit
                                      ? Number(slotProps.row.platformProfit)
                                          .toFixed(3)
                                          .substring(
                                            0,
                                            Number(slotProps.row.platformProfit)
                                              .toFixed(3)
                                              .lastIndexOf(".") + 3
                                          )
                                      : "0.00"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c("div", { staticClass: "line" }),
                        ]
                      },
                    },
                    {
                      key: "platformProfitPrice",
                      fn: function (slotProps) {
                        return [
                          _c(
                            "div",
                            {
                              style: {
                                color:
                                  Number(slotProps.row.platformProfitPrice) < 0
                                    ? "#F63C56"
                                    : "#13CE4B",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    slotProps.row.platformProfitPrice
                                      ? Number(
                                          slotProps.row.platformProfitPrice
                                        )
                                          .toFixed(3)
                                          .substring(
                                            0,
                                            Number(
                                              slotProps.row.platformProfitPrice
                                            )
                                              .toFixed(3)
                                              .lastIndexOf(".") + 3
                                          )
                                      : "0.00"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c("div", { staticClass: "line" }),
                        ]
                      },
                    },
                    {
                      key: "skuNo",
                      fn: function (slotProps) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                slotProps.row.skuNo
                                  ? slotProps.row.skuNo
                                  : "- -"
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                    {
                      key: "status",
                      fn: function (slotProps) {
                        return [
                          _c("el-switch", {
                            attrs: {
                              "active-color": "#2D46EE",
                              "active-value": "1",
                              "inactive-value": "0",
                            },
                            model: {
                              value: slotProps.row.status,
                              callback: function ($$v) {
                                _vm.$set(slotProps.row, "status", $$v)
                              },
                              expression: "slotProps.row.status",
                            },
                          }),
                        ]
                      },
                    },
                    {
                      key: "bindingSkuNo",
                      fn: function (slotBindingSkuNo) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.showDialogSkuVisible(
                                    $event,
                                    slotBindingSkuNo
                                  )
                                },
                              },
                            },
                            [_vm._v("手动绑定SKU")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ]),
        ]),
        _c(
          "div",
          { staticStyle: { "margin-top": "20px" } },
          [
            _c(
              "el-form",
              [
                _c("el-form-item", { attrs: { label: "规格说明" } }, [
                  _c(
                    "div",
                    [
                      _c("el-input", {
                        staticStyle: { width: "442px" },
                        attrs: {
                          placeholder: "请输入规格说明",
                          type: "textarea",
                          maxlength: "200",
                          "show-word-limit": "",
                          rows: 3,
                        },
                        model: {
                          value: _vm.infoForm.specDesc,
                          callback: function ($$v) {
                            _vm.$set(_vm.infoForm, "specDesc", $$v)
                          },
                          expression: "infoForm.specDesc",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "content bottom-but" },
        [
          _c(
            "el-button",
            { attrs: { type: "info" }, on: { click: _vm.back } },
            [_vm._v("返回")]
          ),
          _vm.infoForm.goodsVerifyStatus != "3"
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.verificationData },
                },
                [_vm._v("修改商品")]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "温馨提示",
            visible: _vm.isUp,
            width: "518px",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isUp = $event
            },
          },
        },
        [
          [
            _c("div", { staticStyle: { display: "flex" } }, [
              _c("div", { staticClass: "info" }, [
                _c("i", {
                  staticClass: "el-icon-warning",
                  staticStyle: { color: "red", "font-size": "16px" },
                }),
              ]),
              _c(
                "div",
                { staticStyle: { "margin-left": "8px", "margin-top": "-2px" } },
                [
                  _vm._l(_vm.skuFormConfig.sku, function (item, index) {
                    return _c("div", { key: index, staticClass: "info-item" }, [
                      _c("div", { staticStyle: { display: "flex" } }, [
                        _c("div", { staticStyle: { color: "#2d46ee" } }, [
                          _vm._v(_vm._s(item.firstGoodsSpecName)),
                        ]),
                        _vm._v(" 设置的【盈利金额】为 "),
                        item.platformProfitPrice >= 0
                          ? _c("div", { staticStyle: { color: "#13ce4b" } }, [
                              _vm._v(
                                " " + _vm._s(item.platformProfitPrice) + " "
                              ),
                            ])
                          : _c("div", { staticStyle: { color: "#f63c56" } }, [
                              _vm._v(
                                " -" + _vm._s(item.platformProfitPrice) + " "
                              ),
                            ]),
                        _vm._v(" 元! "),
                      ]),
                      _c("div", { staticClass: "info-b" }, [
                        _vm._v(
                          " 该SKU商品设定【恢复原价个数】为：" +
                            _vm._s(item.resetPriceNum || 0) +
                            "件，扣除保证金"
                        ),
                        _c("span", { staticStyle: { color: "#f63c56" } }, [
                          _vm._v(
                            _vm._s(
                              item.resetPriceNum * item.platformProfitPrice || 0
                            )
                          ),
                        ]),
                        _vm._v("元 "),
                      ]),
                    ])
                  }),
                  _c("div", { staticClass: "info-bottom" }, [
                    _c("div", { staticClass: "info-bottom-item" }, [
                      _vm._v(" 当前可用保证金余额为："),
                      _c("span", { staticStyle: { color: "#13ce4b" } }, [
                        _vm._v(_vm._s(_vm.activeEarnestMoney)),
                      ]),
                      _vm._v("元，将冻结"),
                      _c("span", { staticStyle: { color: "#f63c56" } }, [
                        _vm._v(_vm._s(_vm.awaitEarnestMoney)),
                      ]),
                      _vm._v("元！ "),
                    ]),
                    _c("div", { staticClass: "info-bottom-item" }, [
                      _c("span", { staticStyle: { color: "#f63c56" } }, [
                        _vm._v("*注意："),
                      ]),
                      _vm._v(
                        "当【恢复原价个数】已达上限，则该商品的【市场价、零售价】将自动恢复系统默认价格 "
                      ),
                    ]),
                    _vm.activeEarnestMoney < 0
                      ? _c(
                          "div",
                          {
                            staticClass: "info-bottom-item",
                            staticStyle: {
                              color: "#f63c56",
                              "font-size": "18px",
                              "font-weight": "bold",
                            },
                          },
                          [_vm._v(" 保证金不足，请充值或修改商品数据！ ")]
                        )
                      : _vm._e(),
                    _vm.activeEarnestMoney < 0
                      ? _c("div", { staticClass: "info-bottom-item" }, [
                          _vm._v(" 【保证金充值】请前往"),
                          _c("span", { staticStyle: { color: "#2d46ee" } }, [
                            _vm._v("【财务管理】-【保证金】"),
                          ]),
                          _vm._v("进行充值 "),
                        ])
                      : _vm._e(),
                  ]),
                ],
                2
              ),
            ]),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "end",
                  "margin-top": "24px",
                  "margin-right": "10px",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "info-q",
                    on: {
                      click: function ($event) {
                        _vm.isUp = false
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "info-s",
                    on: { click: _vm.verificationData },
                  },
                  [_vm._v("确定上架")]
                ),
              ]
            ),
          ],
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择商品",
            "append-to-body": true,
            "close-on-click-modal": false,
            visible: _vm.dialogGoods,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogGoods = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { height: "500px", "overflow-y": "auto" } },
            [
              _c(
                "div",
                { staticClass: "search-box" },
                [
                  _c("el-input", {
                    staticStyle: { width: "224px", "margin-right": "20px" },
                    attrs: {
                      placeholder: "请输入商品名称/商品编号",
                      size: "small",
                    },
                    model: {
                      value: _vm.goodsName,
                      callback: function ($$v) {
                        _vm.goodsName = $$v
                      },
                      expression: "goodsName",
                    },
                  }),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.fetchDataG("search")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  ref: "multipleTable",
                  attrs: {
                    data: _vm.goodsList,
                    "show-header": false,
                    border: "",
                  },
                  on: { "selection-change": _vm.handleSelectionChange },
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", width: "60" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "goodsName", label: "" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", { staticStyle: { display: "flex" } }, [
                              _c("img", {
                                staticStyle: {
                                  width: "72px",
                                  height: "56px",
                                  "margin-right": "12px",
                                },
                                attrs: { src: scope.row.image, alt: "" },
                              }),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "14px",
                                    height: "56px",
                                    display: "flex",
                                    "flex-direction": "column",
                                    "justify-content": "space-between",
                                  },
                                },
                                [
                                  _c(
                                    "p",
                                    { staticStyle: { color: "#333333" } },
                                    [_vm._v(_vm._s(scope.row.name))]
                                  ),
                                  _c(
                                    "p",
                                    { staticStyle: { color: "#999999" } },
                                    [
                                      _vm._v(
                                        " 商品编号：" +
                                          _vm._s(scope.row.goodsNo) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "end",
                    "align-items": "center",
                    height: "42px",
                  },
                },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.pageNo,
                      "page-sizes": [5, 10, 20, 30],
                      "page-size": _vm.pageSize,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.totalNum,
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "end",
                "margin-top": "24px",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "info-q",
                  on: {
                    click: function ($event) {
                      _vm.dialogGoods = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "div",
                { staticClass: "info-s", on: { click: _vm.selectData } },
                [_vm._v("确定")]
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }